import {
  FileText,
  Gem,
  Layers,
  Lightbulb,
  Package,
  Palette,
  Users,
  type LucideIcon,
} from 'lucide-react';

export interface TemplateTab {
  label: string;
  path: string;
  icon: LucideIcon;
}

/**
 * Tab set for the template detail shell. Templates have no lifecycle, so —
 * unlike `getEventTabs` — the order is static: structure-authoring surfaces
 * mirror the event's building phase, minus the ops tabs (Live, Submissions,
 * Chat, Activity, Alliances) that only make sense on a running event. Icons
 * match the corresponding event tabs so the two shells read as one system.
 */
export const TEMPLATE_TABS: readonly TemplateTab[] = [
  { label: 'Overview', path: 'overview', icon: FileText },
  { label: 'Challenges', path: 'challenges', icon: Lightbulb },
  { label: 'Stacks', path: 'stacks', icon: Layers },
  { label: 'Artifacts', path: 'artifacts', icon: Gem },
  { label: 'Collectibles', path: 'collectibles', icon: Package },
  { label: 'Teams', path: 'teams', icon: Users },
  { label: 'Branding', path: 'branding', icon: Palette },
];
